const callLogFactory = (level: string) => (message: string, data: Record<string, any>): Promise<Response> => {
  return fetch(`/api/logit/${level}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify([message, data]),
  });
};

export const loglog = {
  info: callLogFactory('info'),
  warn: callLogFactory('warn'),
  error: callLogFactory('error'),
};

export const cookError = (error: Error): Record<string, any> => ({
  message: error.message,
  fileName: error.fileName,
  lineNumber: error.lineNumber,
  columnNumber: error.columnNumber,
  stack: error.stack,
});